export const HEADER_HEIGHT = '62px';

export const NAVBAR_WIDTH = '250px';
